export const FALLBACK_COLOUR = "#cccccc";

export const colourMap: Record<string, string> = {
  // Schwarz-Töne
  schwarz: "#222222",
  anthrazit: "#3e3e3e",
  graphit: "#4a4a4a",
  dunkelgrau: "#616161",
  "dunkel-grau": "#616161",
  eisengrau: "#4f4f4f",
  schiefergrau: "#555f61",
  schwarzbraun: "#2b1a0e",

  // Grau-Töne
  grau: "#9e9e9e",
  mittelgrau: "#757575",
  hellgrau: "#bdbdbd",
  "hell-grau": "#bdbdbd",
  silbergrau: "#b0b0b0",
  steingrau: "#8d8d8d",
  chromgrau: "#888888",
  zementgrau: "#7d7d7d",
  taupe: "#8b8589",
  greige: "#c2b49a",
  mauve: "#b784a7",

  // Weiß-Töne
  weiß: "#f5f5f5",
  weiss: "#f5f5f5",
  weis: "#f5f5f5",
  creme: "#fffdd0",
  cremeweiß: "#f5f0e8",
  cremeweiss: "#f5f0e8",
  ivory: "#fffff0",
  elfenbein: "#f0ead6",
  magnolia: "#f8f4e3",
  offwhite: "#f4f0eb",
  "off-white": "#f4f0eb",
  perlweiß: "#eae0c8",
  perlweiss: "#eae0c8",

  // Silber
  silber: "#c0c0c0",
  chrom: "#dbe0e3",

  // Rot-Töne
  rot: "#d32f2f",
  dunkelrot: "#8b0000",
  bordeaux: "#6b0f2a",
  weinrot: "#722f37",
  kirschrot: "#9b1c31",
  rubinrot: "#9b111e",
  signalrot: "#e8000b",
  koralle: "#ff6f61",
  lachs: "#fa8072",

  // Rosa/Pink
  rosa: "#f48fb1",
  altrosa: "#c08080",
  hellrosa: "#ffb6c1",
  pink: "#e91e63",
  magenta: "#e040fb",
  fuchsia: "#ff00ff",
  himbeere: "#b5294e",

  // Orange
  orange: "#ff9800",
  terrakotta: "#c66c3e",
  terra: "#c66c3e",
  ziegel: "#b5451b",
  rost: "#b7410e",
  ocker: "#cc7722",

  // Gelb
  gelb: "#fdd835",
  sonnengelb: "#ffd700",
  gold: "#ffd700",
  mustard: "#ffdb58",
  curry: "#c8a951",
  senf: "#c8a000",

  // Grün-Töne
  grün: "#4caf50",
  dunkelgrün: "#2e7d32",
  "dunkel-grün": "#2e7d32",
  hellgrün: "#8bc34a",
  olivgrün: "#6b8e23",
  olive: "#808000",
  khaki: "#c3b091",
  mint: "#98ff98",
  mintgrün: "#98ff98",
  salbei: "#8ca882",
  jadegrün: "#00a86b",
  waldgrün: "#355e3b",
  flaschengrün: "#006a4e",
  moosgrün: "#8a9a5b",
  petrol: "#006064",
  türkis: "#00bcd4",
  smaragd: "#50c878",

  // Blau-Töne
  blau: "#1976d2",
  dunkelblau: "#1a237e",
  "dunkel-blau": "#1a237e",
  hellblau: "#81d4fa",
  himmelblau: "#87ceeb",
  navy: "#001f3f",
  marineblau: "#003153",
  royalblau: "#4169e1",
  kobaltblau: "#0047ab",
  stahlblau: "#4682b4",
  taubenblau: "#7ba7bc",
  eisblau: "#b0e0e6",
  jeans: "#4e6a8e",
  denim: "#1560bd",
  indigoblau: "#4b0082",
  indigo: "#4b0082",
  azurblau: "#007fff",

  // Lila/Violett
  lila: "#9c27b0",
  violett: "#7b1fa2",
  flieder: "#c8a2c8",
  lavendel: "#e6e6fa",
  pflaume: "#8e4585",
  aubergine: "#614051",

  // Braun-Töne
  braun: "#795548",
  dunkelbraun: "#4e342e",
  "dunkel-braun": "#4e342e",
  hellbraun: "#a0785a",
  cognac: "#9a463d",
  cappuccino: "#a0785a",
  caramel: "#c68642",
  karamell: "#c68642",
  schokolade: "#3d1c02",
  mokka: "#4a2c2a",
  tabak: "#7a5c41",

  // Natur/Holz
  natur: "#e8d5b7",
  naturholz: "#d4a76a",
  beige: "#d7ccc8",
  sand: "#c2b280",
  sandbeige: "#c8ad7f",
  hellbeige: "#e8dcc8",
  eiche: "#c19a6b",
  wildeiche: "#b8955a",
  eichenholz: "#c19a6b",
  buche: "#d4a76a",
  nussbaum: "#5c3a1e",
  walnuss: "#5c3a1e",
  wenge: "#3c2415",
  kiefer: "#c4a35a",
  bambus: "#daa520",
  ahorn: "#e8c27a",
  birke: "#e8d5b0",
  teak: "#996633",
  pinie: "#c8a26a",

  // Metall
  kupfer: "#b87333",
  bronze: "#cd7f32",
  messing: "#b5a642",
  edelstahl: "#b0b8c0",
  zink: "#a0a4a8",
  nickel: "#a8a9ad",

  // Sonstiges
  multicolor: "conic-gradient(red, orange, yellow, green, blue, violet, red)",
  bunt: "conic-gradient(red, orange, yellow, green, blue, violet, red)",
  mehrfarbig: "conic-gradient(red, orange, yellow, green, blue, violet, red)",
  neongrün: "#39ff14",
  neonpink: "#ff6ec7",
  transparent: "#e8f4f8",
};

export function normaliseColour(raw: string | null | undefined): string | null {
  if (!raw) return null;
  const t = raw.trim();
  if (!t || t === "-" || t === "–" || t.toLowerCase() === "n/a") return null;
  return t;
}

export function colourToHex(colour: string | null | undefined): string {
  if (!colour) return FALLBACK_COLOUR;
  const key = colour.toLowerCase().trim();
  if (colourMap[key]) return colourMap[key];
  for (const [name, hex] of Object.entries(colourMap)) {
    if (key.includes(name) || name.includes(key)) return hex;
  }
  return FALLBACK_COLOUR;
}
